import {ReactElement, useEffect, useState} from "react";

import {getActualites} from "@/api/actualite";
import ContentOnglet from "@/components/ContentOnglet/ContentOnglet";
import ModuleActualite from "@/components/Module/ModuleActualite";
import {actualite} from "@/types/actualite";

function Actualites(): ReactElement {
  const [allActu, setAllActu] = useState<actualite[] | undefined>(undefined);

  useEffect(() => {
    const callPage = async (): Promise<void> => {
      const response = await getActualites();
      setAllActu(response);
    };
    callPage();
  }, []);

  return (
    <ContentOnglet title={"Actualités"}>
      <ModuleActualite actualites={allActu || undefined} />
    </ContentOnglet>
  );
}

export default Actualites;
